export const CORRECT_CONFIRMATION_TEXT = 'deactivate me';